export const TEST_STRIPE_KEY =
    'pk_test_111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111';
